<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        sm6
        md4
      >
        <v-card :color="activeEvents.length ? 'secondary' : 'white'">
          <v-card-title primary-title>
            <div>
              <span :class="{'white--text': activeEvents.length}">אירועים פעילים</span>
              <div class="display-3" :class="{'white--text': activeEvents.length}">{{ activeEvents.length }}</div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn
              v-if="activeEvents.length"
              flat
               :color="activeEvents.length ? 'white' : 'secondary'"
              :to="'/events'"
            >לכל האירועים הפעילים</v-btn>
            <v-btn
            v-else
              flat
              color="secondary"
              :to="'/events/archive'"
            >לארכיון האירועים</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <!-- <v-flex
        xs12
        sm6
        md4
      >
        <v-card>
          <v-card-title primary-title>
            <div>
              <span class="grey--text">אירועים ללא תחקיר</span>
              <div class="display-3">8</div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn
              flat
              color="secondary"
              :to="'/events/archive'"
            >לארכיון האירועים</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex> -->
      <!-- <v-flex
        xs12
        sm6
        md4
      >
        <v-card>
          <v-card-title primary-title>
            <div>
              <span class="grey--text">אירועים חודש נוכחי</span>
              <div class="display-3">27</div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn
              flat
              color="secondary"
              :to="'/reports'"
            >לכל הדו״חות</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex> -->
      <!-- <v-flex
        xs12
        sm6
        md4
      >
        <v-card>
          <v-card-title primary-title>
            <div>
              <span class="grey--text">מאגר מידע - עמידה בתקן</span>
              <div class="display-3">64%</div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn
              flat
              color="secondary"
              :to="'/reports'"
            >לכל הדו״חות</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        sm6
        md4
      >
        <v-card>
          <v-card-title primary-title>
            <div>
              <span class="grey--text">ספקים לאימות השבוע</span>
              <div class="display-3">235</div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn
              flat
              color="secondary"
              :to="'/database'"
            >לרשימת הספקים</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        sm6
        md4
      >
        <v-card>
          <v-card-title primary-title>
            <div>
              <span class="grey--text">ספקים / פג תוקף</span>
              <div class="display-3">23/788</div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn
              flat
              color="secondary"
              :to="'/database'"
            >לרשימת הספקים</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex> -->
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },

  computed: {
    activeEvents() {
      return this.$store.getters["events/activeEvents"];
    }
  },

  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue